<!-- <app-admin-dashboard *ngIf="global.Role=='Admin'"></app-admin-dashboard> -->
<app-user-view *ngIf="global.Role=='Admin'" ></app-user-view>
<app-exam-view *ngIf="global.Role=='Examiner'"></app-exam-view>
